import React from 'react'
import PropTypes from 'prop-types'
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Box,
    Flex,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {MinusIcon, AddIcon} from '@chakra-ui/icons'
import {useIntl} from 'react-intl'
import {
    accordionHeadingStyle,
    accordionPanelStyle,
    iconStyle,
    informationAccordionStyle
} from './index.style'
import useFetchLibraryFolders from '../../../../hooks/useFetchLibrary'

const InformationAccordion = ({product}) => {
    const {formatMessage} = useIntl()
    const {data: response} = useFetchLibraryFolders(`content/pdp-shipping-returns`)

    return (
        <Box>
            <Accordion defaultIndex={[0]} allowMultiple>
                {/*Overview*/}
                {product?.shortDescription && (
                    <AccordionItem sx={informationAccordionStyle}>
                        {({isExpanded}) => (
                            <>
                                <AccordionButton paddingBottom="0">
                                    <Flex w="100%" align="center" justify="space-between">
                                        <Text sx={accordionHeadingStyle}>
                                            {formatMessage({
                                                defaultMessage: 'Overview',
                                                id: 'product_detail.accordion.button.overview'
                                            })}
                                        </Text>
                                        <Box transform="translateY(-50%)">
                                            {isExpanded ? (
                                                <MinusIcon sx={iconStyle} />
                                            ) : (
                                                <AddIcon sx={iconStyle} />
                                            )}
                                        </Box>
                                    </Flex>
                                </AccordionButton>

                                <AccordionPanel sx={accordionPanelStyle}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: product?.shortDescription
                                        }}
                                    />
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )}

                {/* Details */}
                {product?.longDescription && (
                    <AccordionItem sx={informationAccordionStyle}>
                        {({isExpanded}) => (
                            <>
                                <AccordionButton paddingBottom="0">
                                    <Flex w="100%" align="center" justify="space-between">
                                        <Text sx={accordionHeadingStyle}>
                                            {formatMessage({
                                                defaultMessage: 'Details',
                                                id: 'product_detail.accordion.button.details'
                                            })}
                                        </Text>
                                        <Box transform="translateY(-50%)">
                                            {isExpanded ? (
                                                <MinusIcon sx={iconStyle} />
                                            ) : (
                                                <AddIcon sx={iconStyle} />
                                            )}
                                        </Box>
                                    </Flex>
                                </AccordionButton>

                                <AccordionPanel sx={accordionPanelStyle}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: product?.longDescription
                                        }}
                                    />
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )}

                {/* Care Guide */}
                {product?.c_careInstructions && (
                    <AccordionItem sx={informationAccordionStyle}>
                        {({isExpanded}) => (
                            <>
                                <AccordionButton paddingBottom="0">
                                    <Flex w="100%" align="center" justify="space-between">
                                        <Text sx={accordionHeadingStyle}>
                                            {formatMessage({
                                                defaultMessage: 'Care Guide',
                                                id: 'product_detail.accordion.button.care_guide'
                                            })}
                                        </Text>
                                        <Box transform="translateY(-50%)">
                                            {isExpanded ? (
                                                <MinusIcon sx={iconStyle} />
                                            ) : (
                                                <AddIcon sx={iconStyle} />
                                            )}
                                        </Box>
                                    </Flex>
                                </AccordionButton>
                                <AccordionPanel sx={accordionPanelStyle}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: product?.c_careInstructions
                                        }}
                                    />
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )}

                {/* Shipping & Returns */}
                {response?.c_body && (
                    <AccordionItem sx={informationAccordionStyle}>
                        {({isExpanded}) => (
                            <>
                                <AccordionButton paddingBottom="0">
                                    <Flex w="100%" align="center" justify="space-between">
                                        <Text sx={accordionHeadingStyle}>{response.name}</Text>
                                        <Box transform="translateY(-50%)">
                                            {isExpanded ? (
                                                <MinusIcon sx={iconStyle} />
                                            ) : (
                                                <AddIcon sx={iconStyle} />
                                            )}
                                        </Box>
                                    </Flex>
                                </AccordionButton>
                                <AccordionPanel sx={accordionPanelStyle}>
                                    <div dangerouslySetInnerHTML={{__html: response.c_body}} />
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )}
            </Accordion>
        </Box>
    )
}

InformationAccordion.propTypes = {
    product: PropTypes.object
}

export default InformationAccordion
